/* AI 자유대화 끼어들기(barge-in) — 2026-09-30
 *
 * 예전: 피아가 말하는 동안에는 학생이 끼어들 수 없었다(반이중). 🎙 를 눌러도 피아 음성은
 *       계속 나오고 인식만 시작돼, 피아 목소리가 학생 답으로 받아써지기도 했다.
 *
 * 지금 두 가지를 한다.
 *   1) 누르면 끼어들기 — 피아가 말하는 중에 🎙 를 누르거나 입력칸에 글을 쓰면 음성을 즉시 끊는다.
 *      모든 기기(키오스크 포함)에 켠다. 음성 정지 함수(window.piaStopSpeak)를 부를 뿐이다.
 *   2) 말로 끼어들기 — 직전 차례에 학생이 🎙 로 말했다면, 피아가 말하는 동안 음성 인식기를
 *      하나 더 열어 둔다. 인식된 말이 피아가 지금 읽는 문장과 다르면(= 스피커 소리가 아니면)
 *      피아 음성을 끊고, 그대로 이어 들어 학생 답으로 보낸다.
 *      · 에코 판별: 인식 글자의 2글자 묶음 중 절반 이상이 피아 문장(window.__piaLastSpokenText·
 *        마지막 AI 말풍선)에 있으면 스피커 소리로 보고 버린다. 헤드셋이면 거의 걸리지 않는다.
 *      · 기본 켬: 마우스 PC(교실·가정 데스크톱). 기본 끔: 키오스크(저사양 CPU·스피커 되먹임),
 *        휴대폰·태블릿(인식 시작이 재생 중인 음성을 멈추거나 줄이는 기기가 있어 실기기 확인 전까지).
 *      · localStorage 'pia_bargein' = '1' 이면 강제로 켜고 '0' 이면 끈다(현장 검증용).
 *
 * 다른 코드와의 연결
 *   · kiosk.js 서버 음성은 재생 시작·끝에 window.__gttsPlaying 을 true/false 로 바꾼다. 여기서 그
 *     속성을 접근자(get/set)로 바꿔 시작·끝을 알아챈다(kiosk.js 는 고치지 않는다).
 *   · 🎙 버튼 핸들러(pia-main.js rebindMicButton)는 그대로 두고, 캡처 단계 클릭 리스너로 먼저
 *     음성을 끊고 끼어들기 인식기를 닫는다 — 인식기 두 개가 동시에 돌지 않게.
 */
(function () {
  'use strict';
  if (window.__piaBargeIn) return;
  window.__piaBargeIn = 1;

  var SR = window.SpeechRecognition || window.webkitSpeechRecognition;
  var ECHO_RATIO = 0.5;        /* 2글자 묶음 일치율이 이 이상이면 스피커 소리 */
  /* 피아가 말을 끝낸 뒤에도 이만큼 계속 듣는다 → 학생이 🎙 를 다시 누르지 않고 바로 대답하면 그대로 보낸다(이어 듣기).
     2026-10-01 1.5초 → 6초(OWNER '조금 더 고도화'). localStorage 'pia_handsfree'='0' 이면 예전 1.5초. */
  function followMs() { try { if (localStorage.getItem('pia_handsfree') === '0') return 1500; } catch (e) {} return 6000; }
  var followTimer = null;
  var START_DELAY_MS = 250;    /* 음성 재생이 실제로 시작된 뒤 인식기를 연다 */
  var MOBILE_FOLLOW_DELAY = 600; /* 휴대폰: 피아 음성이 끝나고 이만큼 뒤에 연다(첫 문장·나머지 사이 틈과 오디오 세션 전환 여유) */
  var WATCHDOG_MS = 3000;       /* 휴대폰: 시작 신호가 이 안에 없으면 멈춘 것으로 본다(iOS 사파리는 음성 재생 직후 인식이 조용히 멈추는 알려진 문제가 있다) */

  /* ── 말 끝 앞당기기(2026-10-01) ─────────────────────────────
     브라우저는 말이 끝난 뒤 한동안 조용해야 '끝'으로 본다. 중간 결과가 EP_MS 동안 그대로이고
     문장이 끝나는 말꼴(…요/다/야/어/지/네/까/해 등)로 끝나면 먼저 끝낸다.
     '…하고/…는데/…해서/…면'처럼 이어지는 말꼴이면 기다린다(말 중간에 쉬는 아이 보호).
     localStorage 'pia_endpoint'='0' 이면 끈다. */
  var EP_MS = 700;
  var CONT_END = /(고|서|는데|은데|던데|면|면서|지만|니까|해서|려고|랑|이랑|하고|거나|든지|는|을|를|이|가|은|의|도|에|에서|와|과|로|으로|한테|께|처럼|보다|만|까지|부터|그리고|그래서|근데|그런데|그러니까|그리구)$/;
  var FINAL_END = /(요|다|야|어|아|지|네|까|해|래|게|자|냐|니|걸|거든|잖아|죠|음|함|임|듯|ㅋ|ㅎ|[.!?])$/;
  function epOff() { try { return localStorage.getItem('pia_endpoint') === '0'; } catch (e) { return false; } }
  function looksDone(t) {
    t = String(t || '').trim().replace(/[\s,~…]+$/, '');
    if (norm(t).length < 2) return false;
    if (CONT_END.test(t)) return false;
    return FINAL_END.test(t);
  }
  window.__piaLooksDone = looksDone;   /* 검증용 */
  /* r: SpeechRecognition(interimResults=true). isActive(): 지금 판단해도 되는가. getText(ev): 학생 말. */
  window.piaEndpoint = function (r, isActive, getText) {
    if (!r || r.__ep) return; r.__ep = true;
    var orig = r.onresult, timer = null;
    r.onresult = function (ev) {
      if (orig) orig.apply(this, arguments);
      try {
        clearTimeout(timer);
        if (epOff() || (isActive && !isActive())) return;
        var interim = false;
        for (var i = 0; i < ev.results.length; i++) if (!ev.results[i].isFinal) interim = true;
        if (!interim) return;
        var txt = getText ? getText(ev) : (function () { var a = ''; for (var k = 0; k < ev.results.length; k++) a += ev.results[k][0].transcript; return a; })();
        timer = setTimeout(function () {
          if (!looksDone(txt)) return;
          r.__earlyText = String(txt).trim();
          log('말 끝 앞당김', r.__earlyText.slice(-12));
          try { r.stop(); } catch (e) {}
        }, EP_MS);
      } catch (e) { console.error('[barge-in] 말 끝 판단 실패', e); }
    };
  };

  function log() { try { console.log.apply(console, ['[barge-in]'].concat([].slice.call(arguments))); } catch (e) {} }
  function el(id) { return document.getElementById(id); }
  function isKiosk() { return document.documentElement.classList.contains('kiosk-on'); }
  function isTouch() {
    try {
      if (/Android|iPhone|iPad|iPod|Mobile/i.test(navigator.userAgent)) return true;
      if (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1) return true;   /* iPadOS */
      return !!(window.matchMedia && window.matchMedia('(any-pointer: coarse)').matches && !window.matchMedia('(any-pointer: fine)').matches);
    } catch (e) { return false; }
  }
  function pref() { try { return localStorage.getItem('pia_bargein'); } catch (e) { return null; } }
  function voiceAllowed() {
    if (!SR || blocked) return false;
    var p = pref();
    if (p === '0') return false;
    if (p === '1') return true;
    return !isKiosk() && !isTouch();
  }
  /* 이어 듣기(피아 말이 끝난 뒤 듣기)는 휴대폰에도 켠다 — 재생과 인식이 겹치지 않으므로 말로 끼어들기보다 안전하다.
     키오스크는 제외, 시작 신호가 안 오면(followBroken) 이번 방문 동안 끄고 🎙 누르기로 돌아간다. */
  function followAllowed() {
    if (!SR || blocked || followBroken) return false;
    if (pref() === '0') return false;
    try { if (localStorage.getItem('pia_handsfree') === '0') return false; } catch (e) {}
    return !isKiosk();
  }
  function onChat() {
    try { var s = document.querySelector('section[data-view]:not(.hidden)'); return !!s && s.dataset.view === 'chat'; } catch (e) { return false; }
  }
  function status(t) { try { var m = el('chat-mic-status'); if (m) m.textContent = t; } catch (e) {} }

  /* ── 에코(스피커 소리) 판별 ─────────────────────────────── */
  function norm(s) { return String(s || '').toLowerCase().replace(/[^0-9a-z가-힣]/g, ''); }
  function echoRef() {
    var parts = [];
    try { if (window.__piaLastSpokenText) parts.push(window.__piaLastSpokenText); } catch (e) {}
    try {
      var q = el('pia-chat-q'); if (q && q.textContent) parts.push(q.textContent);
      var ai = document.querySelectorAll('#chat-msgs > div.flex:not(.justify-end)');
      for (var i = Math.max(0, ai.length - 2); i < ai.length; i++) parts.push(ai[i].textContent || '');
    } catch (e) {}
    return norm(parts.join(' '));
  }
  function isEcho(text, ref) {
    var n = norm(text);
    if (n.length < 2) return true;               /* 한 글자는 잡음으로 본다 */
    if (!ref) return false;
    var hit = 0, all = 0;
    for (var i = 0; i < n.length - 1; i++) { all++; if (ref.indexOf(n.substr(i, 2)) >= 0) hit++; }
    return all > 0 && (hit / all) >= ECHO_RATIO;
  }
  window.__piaBargeEcho = isEcho;   /* 검증용 */

  /* ── 음성 정지 ─────────────────────────────────────────── */
  function stopSpeak(why) {
    try {
      if (typeof window.piaStopSpeak === 'function') window.piaStopSpeak();
      else if ('speechSynthesis' in window) speechSynthesis.cancel();
    } catch (e) { console.error('[barge-in] 음성 정지 실패', e); }
    try { window.__ttsEchoUntil = 0; } catch (e) {}
    log('음성 정지:', why);
  }

  /* ── 말로 끼어들기 인식기 ──────────────────────────────── */
  var voiceTurn = false;   /* 직전 학생 차례가 음성이었나 */
  var blocked = false;     /* 권한 거부 등으로 이번 방문 동안 끔 */
  var followBroken = false; /* 휴대폰에서 인식 시작 신호가 오지 않음 → 이어 듣기 끔 */
  var mode = '';           /* 'tts'(재생 중 끼어들기) | 'follow'(재생 뒤 이어 듣기) */
  var br = null, barged = false, bargeIdx = -1, cancelled = false, ref = '';
  var startTimer = null, endTimer = null, restarts = 0;

  function closeBr(reason) {
    clearTimeout(startTimer); clearTimeout(endTimer); clearTimeout(followTimer);
    if (!br) return;
    cancelled = true;
    var r = br; br = null;
    try { r.onresult = null; r.onerror = null; r.onend = null; } catch (e) {}
    try { if (r.abort) r.abort(); else r.stop(); } catch (e) {}
    log('인식기 닫음:', reason);
    if (!barged) status('');
    barged = false;
  }

  function micBusy() {
    try { if (window._piaRec2) return true; } catch (e) {}
    try { if (typeof _globalRecording !== 'undefined' && _globalRecording) return true; } catch (e) {}
    return false;
  }

  function openBr(m) {
    var follow = m === 'follow';
    if (br || !voiceTurn || !onChat() || micBusy()) return;
    if (follow ? !followAllowed() : !voiceAllowed()) return;
    var r;
    try { r = new SR(); } catch (e) { console.error('[barge-in] 인식기 생성 실패', e); return; }
    r.lang = window._chatLang || 'ko-KR';
    r.continuous = !isTouch();   /* 휴대폰 크롬은 continuous 가 불안정 — 한 문장씩 */
    r.interimResults = true;
    r.maxAlternatives = 1;
    br = r; mode = follow ? 'follow' : 'tts'; barged = false; bargeIdx = -1; cancelled = false;
    ref = follow ? '' : echoRef();   /* 재생이 끝난 뒤에는 스피커 소리가 없다 — 피아 질문의 낱말을 되받는 대답도 살린다 */
    if (isTouch()) {
      var started = false;
      r.onstart = r.onaudiostart = function () { started = true; };
      setTimeout(function () {
        if (br === r && !started) {
          followBroken = true; closeBr('no-start');
          status('🎙 를 눌러 말해 주세요'); log('시작 신호 없음 — 이어 듣기 끔');
        }
      }, WATCHDOG_MS);
    }

    r.onresult = function (ev) {
      if (br !== r) return;
      if (!barged) {
        for (var i = ev.resultIndex; i < ev.results.length; i++) {
          var t = ev.results[i][0].transcript;
          if (!isEcho(t, ref)) { bargeIdx = i; break; }
        }
        if (bargeIdx < 0) return;           /* 전부 스피커 소리 */
        barged = true;
        stopSpeak('voice');
        voiceTurn = true;
        try { var b = el('chat-mic'); if (b) { b.textContent = '⏹'; b.classList.add('animate-pulse'); } } catch (e) {}
      }
      var fin = '', interim = '';
      for (var j = bargeIdx; j < ev.results.length; j++) {
        var res = ev.results[j];
        if (res.isFinal) fin += res[0].transcript; else interim += res[0].transcript;
      }
      if (interim) status('듣는 중: ' + interim.slice(0, 30));
      if (fin.trim()) {
        var inp = el('chat-input'); if (inp) inp.value = fin.trim();
        status('인식 완료');
        try { r.stop(); } catch (e) {}   /* 한 문장 받으면 끝 → onend 에서 보냄 */
      }
    };
    window.piaEndpoint(r, function () { return barged; }, function (ev) {
      var a = ''; for (var j = Math.max(0, bargeIdx); j < ev.results.length; j++) a += ev.results[j][0].transcript; return a;
    });
    r.onerror = function (ev) {
      var e = ev && ev.error;
      if (e === 'not-allowed' || e === 'service-not-allowed' || e === 'audio-capture') { blocked = true; log('끔:', e); }
      else if (e !== 'no-speech' && e !== 'aborted') console.warn('[barge-in] 인식 오류', e);
    };
    r.onend = function () {
      if (br !== r) return;
      br = null;
      try { var b = el('chat-mic'); if (b) { b.textContent = '🎙'; b.classList.remove('animate-pulse'); } } catch (e) {}
      if (barged && !cancelled) {
        barged = false;
        var inp = el('chat-input');
        if (inp && !inp.value.trim() && r.__earlyText) inp.value = r.__earlyText;   /* 말 끝을 앞당겨 끝낸 경우 */
        if (inp && inp.value.trim()) {
          var send = el('chat-send');
          setTimeout(function () { try { if (send && !send.disabled) send.click(); } catch (e) { console.error('[barge-in] 전송 실패', e); } }, 200);
        } else status('다시 한 번 말씀해 주세요');
        return;
      }
      /* 아직 피아가 말하는 중인데 브라우저가 인식을 끝냈으면(무음 제한) 두 번까지만 다시 연다 */
      if (!cancelled && window.__gttsPlaying && restarts < 2 && mode === 'tts') { restarts++; setTimeout(function () { openBr('tts'); }, 300); }
      else status('');
    };
    try {
      r.start();
      status(follow ? '🎙 듣고 있어요 — 말하면 바로 보내요' : '🎙 피아가 말하는 중에도 말하면 끼어들 수 있어요');
      log('인식기 열림', mode);
    } catch (e) { br = null; console.warn('[barge-in] 시작 실패', e && e.message); }
  }

  function onTtsStart() {
    clearTimeout(endTimer); clearTimeout(followTimer);
    if (br && mode === 'follow' && !barged) { closeBr('tts-again'); }   /* 휴대폰: 재생과 인식을 겹치지 않는다 */
    else if (br) { if (!barged) ref = echoRef(); return; }             /* 이어지는 다음 조각 — 그대로 듣는다 */
    restarts = 0;
    clearTimeout(startTimer);
    startTimer = setTimeout(function () { openBr('tts'); }, START_DELAY_MS);
  }
  function onTtsEnd() {
    clearTimeout(startTimer);
    if (barged) return;
    clearTimeout(endTimer); clearTimeout(followTimer);
    if (!br) {
      /* 재생 중에는 듣지 않는 기기(휴대폰·태블릿): 재생이 끝나면 그때 연다 */
      if (!isTouch() || !voiceTurn) return;
      followTimer = setTimeout(function () { if (!window.__gttsPlaying && !br) openBr('follow'); }, MOBILE_FOLLOW_DELAY);
      endTimer = setTimeout(function () { if (!barged && !window.__gttsPlaying) closeBr('follow-end'); }, MOBILE_FOLLOW_DELAY + followMs());
      return;
    }
    /* 첫 문장과 나머지 사이의 짧은 틈에는 안내를 바꾸지 않는다. 재생이 정말 끝났으면 에코 판별도 끈다. */
    followTimer = setTimeout(function () { if (br && !barged && !window.__gttsPlaying) { ref = ''; status('🎙 듣고 있어요 — 말하면 바로 보내요'); } }, 500);
    endTimer = setTimeout(function () { if (!barged && !window.__gttsPlaying) closeBr('tts-end'); }, followMs());
  }

  /* kiosk.js 가 쓰는 window.__gttsPlaying 을 접근자로 바꿔 재생 시작·끝을 알아챈다. */
  try {
    var playing = !!window.__gttsPlaying;
    Object.defineProperty(window, '__gttsPlaying', {
      configurable: true,
      get: function () { return playing; },
      set: function (v) {
        var prev = playing; playing = !!v;
        if (!prev && playing) onTtsStart();
        else if (prev && !playing) onTtsEnd();
      }
    });
  } catch (e) { console.error('[barge-in] 재생 감시 설치 실패', e); }

  /* ── 누르면 끼어들기 + 차례 종류 기록 ───────────────────── */
  document.addEventListener('click', function (ev) {
    var t = ev.target && ev.target.closest ? ev.target.closest('#chat-mic, #mv-start-voice') : null;
    if (!t) return;
    voiceTurn = true;
    if (br) closeBr('mic-tap');
    if (window.__gttsPlaying) stopSpeak('tap');
  }, true);

  document.addEventListener('input', function (ev) {
    if (!ev.target || ev.target.id !== 'chat-input' || barged) return;
    voiceTurn = false;                       /* 글로 답하는 학생 — 마이크를 열지 않는다 */
    if (br) closeBr('typing');
    if (window.__gttsPlaying) stopSpeak('typing');
  }, true);

  /* 화면을 떠나거나 숨기면 닫는다 */
  document.addEventListener('visibilitychange', function () { if (document.hidden) closeBr('hidden'); });
  window.addEventListener('pagehide', function () { closeBr('pagehide'); });

  window.piaBargeIn = { state: function () { return { voiceTurn: voiceTurn, open: !!br, mode: br ? mode : '', barged: barged, allowed: voiceAllowed(), follow: followAllowed(), followBroken: followBroken }; }, close: closeBr };
})();
